/**
 * @flow
 */
import React from "react";
import {Redirect} from "react-router-dom";
import dashboardRoutes from "./views/dashboard/dashboardRoutes";
import commonRoutes from './views/common/commonRoutes';
import settingsRoutes from './views/settings/settingsRoutes';
import logsRoutes from './views/logs/logsRoutes';
import reportsRoutes from './views/reports/reportsRoutes';
import {ROUTE} from './settings';

const routes = [
  ...commonRoutes,
  ...dashboardRoutes,
  ...reportsRoutes,
  ...settingsRoutes,
  ...logsRoutes,
  {component: () => <Redirect to={ROUTE.DASHBOARD_OVERVIEW}/>},
];

export default routes;
